"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

require("waypoints/lib/jquery.waypoints");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $body = void 0;

var $document = void 0;
var Creators_Page = void 0;

$document = require("../helpers/helpers").default.document;

$body = require("../helpers/helpers").default.body;

Creators_Page = function () {
  function Creators_Page() {
    $document.ready(function () {

      return $body.on("click", ".scroll-down", function (e) {
        var target = void 0;
        e.preventDefault();
        target = (0, _jquery2.default)(this).attr("href");
        return (0, _jquery2.default)("html, body").animate({
          scrollTop: (0, _jquery2.default)(target).offset().top
        }, 500);
      });
    });
    (0, _jquery2.default)(".section-block").waypoint({
      handler: function handler() {

        return (0, _jquery2.default)(this).addClass("in-view");
      },

      offset: "100%"
    });
  }

  return Creators_Page;
}();

exports.default = Creators_Page;